import {ResponsiveImage} from '@legit-health/ui';
import HomeIcon from '@mui/icons-material/Home';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import {Box, Typography, Button} from '@mui/material';
import {Link} from '@tanstack/react-router';
import {useTranslation} from 'react-i18next';
import {APP_HOME} from '@/anonymous/routing/paths';
import {SUPPORT} from '@/public/routing/paths';
import robotBody from '@/shared/images/error-robot-body.svg';
import robotHead from '@/shared/images/error-robot-head.svg';

export default function NotFoundPage() {
  const {t} = useTranslation(['anonymous/views']);
  return (
    <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh'}}>
      <Box
        sx={{
          maxWidth: {
            xs: 'none',
            lg: '50%'
          }
        }}
      >
        <ResponsiveImage src={robotHead} alt="404" />
        <Box
          sx={{
            mt: 1,
            mb: -2,
            textAlign: 'center'
          }}
        >
          <Typography variant="h2">{t('anonymous/views:notFoundPage.subtitle')}</Typography>
          <Typography
            sx={{
              mb: '16px'
            }}
          >
            {t('anonymous/views:notFoundPage.text')}
          </Typography>
        </Box>
        <ResponsiveImage src={robotBody} alt="404" />
        <Button
          startIcon={<HomeIcon />}
          size="large"
          disableElevation
          fullWidth
          variant="contained"
          component={Link}
          to={APP_HOME}
        >
          {t('anonymous/views:notFoundPage.cta')}
        </Button>
        <Typography
          variant="body2"
          sx={{
            mt: 3,
            textAlign: 'center'
          }}
        >
          {t('anonymous/views:notFoundPage.support')}
        </Typography>
        <Button
          startIcon={<SupportAgentIcon />}
          fullWidth
          component={Link}
          to={SUPPORT}
          color="secondary"
          variant="text"
        >
          {t('anonymous/views:notFoundPage.supportCta')}
        </Button>
      </Box>
    </Box>
  );
}
